var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSm01ButtonPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2718 1.8335C18.3885 1.8335 20.1668 3.5935 20.1668 6.71933V15.281C20.1668 18.3885 18.3977 20.1668 15.281 20.1668H6.71933C3.5935 20.1668 1.8335 18.3885 1.8335 15.281V6.71933C1.8335 3.5935 3.5935 1.8335 6.71933 1.8335H15.2718ZM10.991 6.88433C10.5693 6.88433 10.2302 7.2235 10.2302 7.64516V10.2302H7.636C7.43433 10.2302 7.24183 10.3127 7.09516 10.4502C6.95766 10.5968 6.87516 10.7884 6.87516 10.991C6.87516 11.4127 7.21433 11.7518 7.636 11.761H10.2302V14.3552C10.2302 14.7768 10.5693 15.116 10.991 15.116C11.4127 15.116 11.7518 14.7768 11.7518 14.3552V11.761H14.3552C14.7768 11.7518 15.116 11.4127 15.116 10.991C15.116 10.5693 14.7768 10.2302 14.3552 10.2302H11.7518V7.64516C11.7518 7.2235 11.4127 6.88433 10.991 6.88433Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm01ButtonPlus);
export default __webpack_public_path__ + "static/media/SM01-button-plus.74b0e8df1359f823f2def0e64f0db68b.svg";
export { ForwardRef as ReactComponent };